import React from "react";
import { 
  FaCode,
  FaRobot,
  FaChartLine
} from "react-icons/fa";

const servicesData = [
  {
    icon: <FaRobot className="text-3xl text-blue-400" />,
    title: "AI-Powered Business Solutions",
    description:
      "Designing and integrating AI solutions tailored to your business: intelligent chatbots, workflow automation, and predictive analytics that help you work smarter and scale faster.",
    skills: [
      "AI Strategy",
      "Chatbots",
      "Process Automation",
      "Predictive Analytics",
      "LLM Integration"
    ]
  },
  {
    icon: <FaCode className="text-3xl text-purple-400" />,
    title: "Full-Stack Web Applications",
    description:
      "Building secure, production-ready web applications from frontend to backend using modern frameworks and clean architecture. Every project is optimized for performance, scalability, and maintainability.",
    skills: [
      "React",
      "Next.js",
      "Node.js",
      "REST APIs",
      "Authentication"
    ]
  },
  {
    icon: <FaChartLine className="text-3xl text-emerald-400" />,
    title: "Data Science & Analytics",
    description:
      "Transforming raw data into clear, actionable insights using Python, NumPy, and Pandas. I build analytical dashboards and machine learning models that support confident, data-driven decisions.",
    skills: [
      "Python",
      "NumPy",
      "Pandas",
      "Data Visualization",
      "Machine Learning"
    ]
  }
];

function Services() {
  return (
    <section id="services" className="min-h-screen bg-gradient-to-br from-[#0B1120] via-[#132037] to-[#1B2B4B] py-12 md:py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#F1F5F9] mb-4">
            My <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500">Services</span>
          </h2>
          <p className="text-[#94A3B8] max-w-3xl mx-auto text-lg">
            Focused, high-impact services: AI-powered business solutions, full-stack web applications, and data science. Every project is delivered with a modern tech stack and a professional, long-term mindset.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service, index) => (
            <div 
              key={index}
              className="group bg-[#020617]/70 border border-[#1E293B]/70 rounded-2xl p-7 
                        shadow-md shadow-black/40 backdrop-blur-sm
                        transition-all duration-300 hover:border-[#60A5FA]/70 hover:shadow-2xl hover:shadow-[#60A5FA]/30
                        hover:-translate-y-2 hover:scale-[1.02] flex flex-col"
            >
              <div className="flex items-center mb-4">
                <div className="p-3 rounded-xl mr-4 bg-gradient-to-br from-[#1D4ED8]/20 via-[#0F172A] to-[#7C3AED]/20
                            border border-[#334155]/70 shadow-inner shadow-black/40
                            transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-3">
                  {service.icon}
                </div>
                <h3 className="text-xl font-semibold text-[#F1F5F9]">{service.title}</h3>
              </div>
              <p className="text-[#CBD5E1] mb-5 flex-grow">{service.description}</p>
              
              {/* Skills Chips */}
              <div className="flex flex-wrap gap-2 mt-auto">
                {service.skills.map((skill, i) => (
                  <span 
                    key={i}
                    className="text-xs px-3 py-1 bg-[#020617] border border-[#1E293B] text-[#CBD5E1] rounded-full
                               transition-colors duration-200 group-hover:border-[#60A5FA]/60"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Call-to-Action */}
        <div className="text-center mt-16">
          <p className="text-[#94A3B8] mb-6 text-lg">
            Have a project in mind? Let's discuss how I can help bring your vision to life with modern tech and AI-driven solutions!
          </p>
          <a 
            href="/contact" 
            className="inline-block px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg 
                      hover:shadow-lg hover:shadow-blue-500/30 transition-all duration-300"
          >
            Get In Touch
          </a>
        </div>
      </div>
    </section>
  );
}

export default Services;
